<template>
  <teleport to="body">
    <transition name="fab-fade">
      <div
        v-if="visible"
        class="group-booking-fab"
        @click="handleClick"
        title="Đặt xe riêng cho tổ chức / Doanh nghiệp – Tối thiểu 16 chỗ"
        role="button"
        tabindex="0"
        @keydown.enter="handleClick"
        @keydown.space.prevent="handleClick"
      >
        <!-- Ping animation -->
        <span class="fab-ping"></span>

        <!-- Card nội dung -->
        <div class="fab-body">
          <div class="fab-icon-wrap">
            <!-- Bus / corporate transport icon -->
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="fab-svg-icon">
              <path d="M4 16c0 .88.39 1.67 1 2.22V20a1 1 0 001 1h1a1 1 0 001-1v-1h8v1a1 1 0 001 1h1a1 1 0 001-1v-1.78c.61-.55 1-1.34 1-2.22V6c0-3.5-3.58-4-8-4s-8 .5-8 4v10zm3.5 1a1.5 1.5 0 110-3 1.5 1.5 0 010 3zm9 0a1.5 1.5 0 110-3 1.5 1.5 0 010 3zM6 6h12v4H6V6z"/>
            </svg>
          </div>
          <div class="fab-text">
            <span class="fab-badge">DOANH NGHIỆP</span>
            <span class="fab-title">Đặt xe tổ chức</span>
            <span class="fab-desc">Từ 16 chỗ – Xe riêng</span>
          </div>
          <div class="fab-caret">
            <i class="fas fa-chevron-left"></i>
          </div>
        </div>
      </div>
    </transition>
  </teleport>
</template>

<script>
const SESSION_KEY = 'group_fab_seen'

export default {
  name: 'GroupBookingBanner',
  emits: ['open-modal'],

  data() {
    return {
      visible: false
    }
  },

  mounted() {
    // Chỉ hiện khi lần đầu vào trang trong session này
    if (!sessionStorage.getItem(SESSION_KEY)) {
      this.visible = true
      // Sau 8 giây tự ẩn
      this._autoHide = setTimeout(() => this.dismiss(), 8000)
      // Ẩn khi user scroll
      this._onScroll = () => this.dismiss()
      window.addEventListener('scroll', this._onScroll, { passive: true, once: true })
    }
  },

  beforeUnmount() {
    clearTimeout(this._autoHide)
    if (this._onScroll) window.removeEventListener('scroll', this._onScroll)
  },

  methods: {
    dismiss() {
      this.visible = false
      sessionStorage.setItem(SESSION_KEY, '1')
      clearTimeout(this._autoHide)
      if (this._onScroll) window.removeEventListener('scroll', this._onScroll)
    },
    handleClick() {
      this.dismiss()
      this.$emit('open-modal')
    }
  }
}
</script>

<style lang="scss" scoped>
/* ─ Transition ─────────────────────────────────────────────── */
.fab-fade-enter-active   { transition: opacity 0.4s ease, transform 0.4s ease; }
.fab-fade-leave-active   { transition: opacity 0.35s ease, transform 0.35s ease; }
.fab-fade-enter-from,
.fab-fade-leave-to       { opacity: 0; transform: translateX(30px) translateY(-50%); }
.fab-fade-enter-to,
.fab-fade-leave-from     { opacity: 1; transform: translateX(0) translateY(-50%); }

/* ─ Base FAB ──────────────────────────────────────────────────*/
.group-booking-fab {
  position: fixed;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  z-index: 900;
  cursor: pointer;
  outline: none;
  user-select: none;

  &:focus-visible .fab-body {
    box-shadow: -4px 0 0 3px rgba(37, 99, 235, 0.6),
                -6px 6px 28px rgba(37, 99, 235, 0.5);
  }
}

/* ─ Ping ───────────────────────────────────────────────────── */
.fab-ping {
  position: absolute;
  top: 8px;
  right: 8px;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: #0ea5e9;
  z-index: 1;

  &::before {
    content: '';
    position: absolute;
    inset: -5px;
    border-radius: 50%;
    background: rgba(245, 158, 11, 0.45);
    animation: ping 1.6s ease-out infinite;
  }
}

@keyframes ping {
  0%   { transform: scale(0.8); opacity: 0.8; }
  70%  { transform: scale(2); opacity: 0; }
  100% { transform: scale(2); opacity: 0; }
}

/* ─ Body card ──────────────────────────────────────────────── */
.fab-body {
  display: flex;
  align-items: center;
  gap: 0.6rem;
  padding: 0.75rem 0.85rem 0.75rem 0.9rem;
  background: linear-gradient(135deg, #0ea5e9 0%, #075985 60%, #064e3b 100%);
  border-radius: 1rem 0 0 1rem;
  color: #fff;
  box-shadow: -6px 4px 28px rgba(29, 78, 216, 0.55);
  transition: all 0.28s cubic-bezier(0.34, 1.56, 0.64, 1);
  animation: fab-glow 2.8s ease-in-out infinite;
}

@keyframes fab-glow {
  0%, 100% { box-shadow: -6px 4px 28px rgba(29, 78, 216, 0.5); }
  50%       { box-shadow: -6px 6px 40px rgba(29, 78, 216, 0.82), -2px 2px 16px rgba(96, 165, 250, 0.4); }
}

.group-booking-fab:hover .fab-body {
  padding-right: 1.1rem;
  box-shadow: -8px 6px 40px rgba(29, 78, 216, 0.72);
  animation: none;
  transform: translateX(-4px);
}

.group-booking-fab:active .fab-body {
  transform: translateX(-2px) scale(0.97);
}

/* ─ Icon ────────────────────────────────────────────────────── */
.fab-icon-wrap {
  width: 40px;
  height: 40px;
  min-width: 40px;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
  backdrop-filter: blur(4px);
  border: 1px solid rgba(255,255,255,0.18);
}

.fab-svg-icon {
  width: 22px;
  height: 22px;
  color: #fff;
}

/* ─ Text ────────────────────────────────────────────────────── */
.fab-text {
  display: flex;
  flex-direction: column;
  line-height: 1.2;
  white-space: nowrap;
  gap: 0.08rem;
}

.fab-badge {
  font-size: 0.55rem;
  font-weight: 600;
  letter-spacing: 0.08em;
  background: rgba(251, 191, 36, 0.9);
  color: #064e3b;
  padding: 0.1rem 0.4rem;
  border-radius: 999px;
  align-self: flex-start;
  line-height: 1.4;
  text-transform: uppercase;
}

.fab-title {
  font-size: 0.85rem;
  font-weight: 600;
  letter-spacing: 0.01em;
}

.fab-desc {
  font-size: 0.68rem;
  font-weight: 500;
  opacity: 0.82;
}

/* ─ Caret ───────────────────────────────────────────────────── */
.fab-caret {
  opacity: 0.65;
  transition: opacity 0.2s, transform 0.2s;
  margin-left: auto;

  i {
    font-size: 0.65rem;
  }

  .group-booking-fab:hover & {
    opacity: 1;
    transform: translateX(-2px);
  }
}

/* ─── Mobile ────────────────────────────────────────────────── */
@media (max-width: 640px) {
  .group-booking-fab {
    top: auto;
    bottom: 76px;
    transform: none;

    &:hover .fab-body {
      transform: translateX(-4px);
    }
  }

  /* Fix transition on mobile (no translateY) */
  .fab-fade-enter-from,
  .fab-fade-leave-to     { transform: translateX(30px); }
  .fab-fade-enter-to,
  .fab-fade-leave-from   { transform: translateX(0); }
}
</style>
